module.exports = __webpack_public_path__ + "Roboto-Regular.3e1af3ef546b9e6ecef9.ttf";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Regular.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Regular.ttf
// module chunks = main